<template>
  <div class="row mt-3">
    <div class="col-md-12 px-gap">
      <div class="card m-b-10 shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Tren Tendensi Harian</h4>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <highcharts :options="dataLine" :ref="linechart_id"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  name: "tren_tendency",
  components: {
    highcharts: Chart,
  },
  props: {
    data: {
      default: null,
      type: Object,
    },
    linechart_id: String,
  },
  data() {
    return {
      dataLine: {},
    };
  },
  methods: {
    dataLineChart: function () {
      this.dataLine = {
        chart: {
          type: "line",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.data.categories,
        },
        yAxis: {
          title: {
            text: "Temperature (°C)",
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [
          this.data.series[0],
          this.data.series[1],
          this.data.series[2],
          this.data.series[3],
          this.data.series[4],
          this.data.series[5],
          this.data.series[6],
          this.data.series[7],
          this.data.series[8],
          this.data.series[9],
          this.data.series[10],
          this.data.series[11],
        ],
      };
    },
  },

  mounted() {
    if (this.data) {
      this.dataLineChart();
    }
  },
};
</script>